// TODO delete WithId and use WithId2 after old DTOs are refactored (and optional/undefined fields are not used anymore)
export interface WithId {
  id?: number | null;
}

export interface WithId2 {
  id: number | null;
}

export const findValueById = <T extends WithId>(values: T[] | undefined, id: number | undefined): T | undefined => {
  if (!id) {
    return undefined;
  }
  if (!values) {
    return undefined;
  }
  return values.find((v) => v.id === id);
};

/**
 * Split array into chunks
 * @param array a large array to split
 * @param chunkSize chunk size
 */
export function splitIntoChunks<T>(array: T[], chunkSize: number): T[][] {
  const chunks: T[][] = [];
  let i;
  let j;
  for (i = 0, j = array.length; i < j; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize));
  }
  return chunks;
}

export function addIfNotIn<T extends WithId2>(array: T[], elem: T) {
  const found = array.some(el => el.id === elem.id);
  if (!found) {
    array.splice(0, 0, elem);
  }
}

export function addElementsIfNotIn<T extends WithId2>(array: T[], elements: T[]) {
  const notIn: T[] = [];
  elements.forEach((e) => {
    if (!array.some(el => el.id === e.id)) {
      notIn.push(e)
    }
  })
  array.splice(0, 0, ...notIn);
}




// WEBPACK FOOTER //
// ./src/utils/utils.tsx